export const khanmigoTexKey = "tex/khanmigo";
